import { WorkflowService } from '../services/WorkflowService';

export function useWorkflowService(): WorkflowService {
  return new WorkflowService(useApiClient(), useUserStore());
}
